'use strict';

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global _ */
/* global Backbone */
/**
Marionette Binding

Copyright 2015 Pebble
*/
var Marionette = null;

if (window['Backbone'] && window['Marionette']) {
  Marionette = Backbone.Marionette;
} else {
  Marionette = require('backbone.marionette');
}

/*
This looks after a value to monitor on the model. This allows us to do
some neat things such as "value__isnull" a la Django style
*/

var ModelValue = exports.ModelValue = (function () {
  function ModelValue(model, key) {
    _classCallCheck(this, ModelValue);

    this.model = model;
    this.key = key;
  }

  _createClass(ModelValue, [{
    key: 'get',
    value: function get() {
      return this.model.get(this.key);
    }
  }, {
    key: 'set',
    value: function set(val, args) {
      return this.model.set(this.key, val, args);
    }
  }, {
    key: 'change',
    value: function change(fn) {
      this.model.on("change:" + this.key, fn);
    }
  }]);

  return ModelValue;
})();

var IsNullValue = exports.IsNullValue = (function (_ModelValue) {
  _inherits(IsNullValue, _ModelValue);

  function IsNullValue(model, key) {
    _classCallCheck(this, IsNullValue);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(IsNullValue).call(this, model, key));

    _this.oldValue = '';
    return _this;
  }

  _createClass(IsNullValue, [{
    key: 'get',
    value: function get() {
      return _get(Object.getPrototypeOf(IsNullValue.prototype), 'get', this).call(this) == null;
    }
  }, {
    key: 'set',
    value: function set(val, args) {
      if (val == true) {
        this.oldValue = _get(Object.getPrototypeOf(IsNullValue.prototype), 'get', this).call(this);
        return _get(Object.getPrototypeOf(IsNullValue.prototype), 'set', this).call(this, null, args);
      } else {
        return _get(Object.getPrototypeOf(IsNullValue.prototype), 'set', this).call(this, this.oldValue, args);
      }
    }
  }]);

  return IsNullValue;
})(ModelValue);

var NotValue = exports.NotValue = (function (_ModelValue2) {
  _inherits(NotValue, _ModelValue2);

  function NotValue() {
    _classCallCheck(this, NotValue);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NotValue).apply(this, arguments));
  }

  _createClass(NotValue, [{
    key: 'get',
    value: function get() {
      return !_get(Object.getPrototypeOf(NotValue.prototype), 'get', this).call(this);
    }
  }, {
    key: 'set',
    value: function set(val, args) {
      _get(Object.getPrototypeOf(NotValue.prototype), 'set', this).call(this, !val, args);
    }
  }]);

  return NotValue;
})(ModelValue);

var ValueLookups = exports.ValueLookups = {
  'eq': ModelValue,
  'isnull': IsNullValue,
  'not': NotValue
};

/*
This deals with the binding and keeping it all up to date

@abstract
*/

var Binding = exports.Binding = (function () {
  function Binding(element, val, jQ, args) {
    _classCallCheck(this, Binding);

    this.element = element;
    this.val = val;
    this.$ = jQ;
    this.args = args;
  }

  _createClass(Binding, [{
    key: 'start',
    value: function start() {
      throw new Error("start() not implemented");
    }
  }]);

  return Binding;
})();

var ValueBinding = exports.ValueBinding = (function (_Binding) {
  _inherits(ValueBinding, _Binding);

  function ValueBinding() {
    _classCallCheck(this, ValueBinding);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ValueBinding).apply(this, arguments));
  }

  _createClass(ValueBinding, [{
    key: 'start',
    value: function start() {
      var _this4 = this;

      // Initial Value
      this.element.val(this.val.get());

      // Update
      var eventHandler = function eventHandler() {
        _this4.val.set(_this4.element.val(), { _sender: _this4.element });
      };
      this.element.on("keyup", eventHandler).on("change", eventHandler).on("__updated", eventHandler);

      // Listen to changes
      this.val.change(function (model, value, options) {
        if (options['_sender'] == _this4.element) return; // Don't loop!
        _this4.element.val(_this4.val.get());
      });
    }
  }]);

  return ValueBinding;
})(Binding);

var TextBinding = exports.TextBinding = (function (_Binding2) {
  _inherits(TextBinding, _Binding2);

  function TextBinding() {
    _classCallCheck(this, TextBinding);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(TextBinding).apply(this, arguments));
  }

  _createClass(TextBinding, [{
    key: 'start',
    value: function start() {
      var _this6 = this;

      // Initial Value
      this.element.text(this.val.get());

      // Listen to changes
      this.val.change(function (model, value) {
        _this6.element.text(_this6.val.get());
      });
    }
  }]);

  return TextBinding;
})(Binding);

var HtmlBinding = exports.HtmlBinding = (function (_Binding3) {
  _inherits(HtmlBinding, _Binding3);

  function HtmlBinding() {
    _classCallCheck(this, HtmlBinding);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(HtmlBinding).apply(this, arguments));
  }

  _createClass(HtmlBinding, [{
    key: 'start',
    value: function start() {
      var _this8 = this;

      // Initial Value
      this.element.html(this.val.get());

      // Listen to changes
      this.val.change(function (model, value) {
        _this8.element.html(_this8.val.get());
      });
    }
  }]);

  return HtmlBinding;
})(Binding);

var DisabledBinding = exports.DisabledBinding = (function (_Binding4) {
  _inherits(DisabledBinding, _Binding4);

  function DisabledBinding() {
    _classCallCheck(this, DisabledBinding);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(DisabledBinding).apply(this, arguments));
  }

  _createClass(DisabledBinding, [{
    key: 'start',
    value: function start() {
      this.val.change(_.bind(this.change, this));
      this.change();
    }
  }, {
    key: 'change',
    value: function change() {
      if (this.val.get() == true) {
        this.element.attr("disabled", "disabled");
      } else {
        this.element.removeAttr("disabled");
      }
    }
  }]);

  return DisabledBinding;
})(Binding);

var VisibleBinding = exports.VisibleBinding = (function (_Binding5) {
  _inherits(VisibleBinding, _Binding5);

  function VisibleBinding() {
    _classCallCheck(this, VisibleBinding);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(VisibleBinding).apply(this, arguments));
  }

  _createClass(VisibleBinding, [{
    key: 'start',
    value: function start() {
      this.val.change(_.bind(this.change, this));
      this.change();
    }
  }, {
    key: 'change',
    value: function change() {
      if (this.val.get() == true) {
        this.element.hide();
      } else {
        this.element.show();
      }
    }
  }]);

  return VisibleBinding;
})(Binding);

var ClassBinding = exports.ClassBinding = (function (_Binding6) {
  _inherits(ClassBinding, _Binding6);

  function ClassBinding() {
    _classCallCheck(this, ClassBinding);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ClassBinding).apply(this, arguments));
  }

  _createClass(ClassBinding, [{
    key: 'start',
    value: function start() {
      this.val.change(_.bind(this.change, this));
      this.change();
    }
  }, {
    key: 'change',
    value: function change() {
      if (this.args) {
        if (this.val.get() == true) {
          this.element.addClass(this.args);
        } else {
          this.element.removeClass(this.args);
        }
      } else {
        this.element.attr("class", this.val.get());
      }
    }
  }]);

  return ClassBinding;
})(Binding);

var CheckedBinding = exports.CheckedBinding = (function (_Binding7) {
  _inherits(CheckedBinding, _Binding7);

  function CheckedBinding() {
    _classCallCheck(this, CheckedBinding);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CheckedBinding).apply(this, arguments));
  }

  _createClass(CheckedBinding, [{
    key: 'start',
    value: function start() {
      var _this13 = this;

      // Update
      this.element.on("click", function (e) {
        var tick = _this13.$(e.target);
        var type = tick.attr("type");
        if (type == "radio") {
          _this13.val.set(tick.attr('value'), { _sender: _this13.element });
        } else if (type == "checkbox") {
          _this13.val.set(tick.is(':checked'), { _sender: _this13.element });
        }
      });

      // Listen to changes
      this.val.change(_.bind(this.change, this));
      this.change(null, this.val.get(), {});
    }
  }, {
    key: 'change',
    value: function change(model, wrong_value, options) {
      var _this14 = this;

      var value = this.val.get();
      if (options['_sender'] == this.element) return; // Don't loop!
      this.element.each(function (k, v) {
        var type = _this14.$(v).attr("type");
        if (type == "checkbox") {
          _this14.$(v).prop("checked", value);
        } else if (type == "radio") {
          if (_this14.$(v).attr("value") == value) {
            _this14.$(v).get(0).checked = true;
          }
        }
      });
    }
  }]);

  return CheckedBinding;
})(Binding);

var Bindings = exports.Bindings = {
  'value': ValueBinding,
  'text': TextBinding,
  'html': HtmlBinding,
  'checked': CheckedBinding,
  'disabled': DisabledBinding,
  'visible': VisibleBinding,
  'class': ClassBinding
};

var BindingMixin = exports.BindingMixin = {
  bindings: {},
  onRender: function onRender() {
    this.startBindings();
  },

  startBindings: function startBindings(model, bindings) {
    if (!model) {
      model = this.model;
    }
    if (!bindings) {
      bindings = this.bindings;
    }

    if (!model) {
      // No model - no bindings!
      return;
    }

    _.each(bindings, function (what, bind_to) {
      // Split up the definition
      var binding = bind_to.split(" ");
      if (binding.length != 2) {
        throw new Error("Binding not setup correctly");
      }

      // Deal with the binding definition
      var type = binding[0];
      var el = binding[1];
      // @ui.etc is dealt with
      if (el.indexOf("@ui.") == 0) {
        el = this.ui[el.substr(4)];
        if (el == undefined) {
          // keeps it working + choice by
          // https://bocoup.com/weblog/jquery-fastest-way-to-select-nothing/
          el = this.$(false);
        }
      } else {
        // everything else
        el = this.$(el);
      }

      var lookup = what.split('__');
      var val = null;
      if (lookup.length >= 2) {
        lookup = lookup[lookup.length - 1];
        if (!ValueLookups[lookup]) {
          throw new Error("Value lookup not found for " + lookup);
        }
        val = new ValueLookups[lookup](model, what.substr(0, what.length - lookup.length - 2));
      } else {
        val = new ModelValue(model, what);
      }

      var args = '';
      if (type.indexOf(":") > 0) {
        args = type.substr(type.indexOf(":") + 1);
        type = type.substr(0, type.indexOf(":"));
      }

      if (Bindings[type]) {
        var _binding = new Bindings[type](el, val, _.bind(this.$, this), args);
        _binding.start();
      } else {
        throw new Error("Binding not found for " + type);
      }
    }, this);
  }
};

var BindedView = exports.BindedView = Marionette.LayoutView.extend(BindingMixin);


//////////////////
// WEBPACK FOOTER
// ../node_modules/marionette.binding/lib/marionette.binding.js
// module id = 20
// module chunks = 0